import { Component, OnInit, ViewChild } from '@angular/core';
import { QuillEditorComponent } from 'ngx-quill';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IComplaintCategory } from 'src/app/interface/dto';
import { ComplaintService } from 'src/app/services/complaint-services.service';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-add-complaint-category',
  templateUrl: './add-complaint-category.component.html',
  styleUrls: ['./add-complaint-category.component.scss']
})
export class AddComplaintCategoryComponent implements OnInit {

  selectedCategory: IComplaintCategory = {
    categoryID: '',
    categoryText: '',
    helpText: ''
  };
  text = 'Add';
  @ViewChild('editor') editor: QuillEditorComponent;

  constructor(private popoverRef: PopoverRef<AddComplaintCategoryComponent>,
    private complaintService: ComplaintService, private snackBar: SnackbarService, private evnt: EventService) { }

  ngOnInit() {
    let cat = JSON.parse(sessionStorage.getItem("selectedComplaintCategory")) as IComplaintCategory
    if (cat) {
      this.selectedCategory = cat;
      this.selectedCategory.helpText = this.selectedCategory.helpText.replace(/^"|"$/g, '');
      this.text = 'Update';
    }
  }

  async ngAfterViewInit() {
    this.editor.onEditorCreated.subscribe(() => {
      if(this.selectedCategory.categoryID !== '') {
        this.editor.quillEditor.clipboard.dangerouslyPasteHTML(this.selectedCategory.helpText);
      }
    });
  }
  close() {
    this.popoverRef.close();
    sessionStorage.setItem("selectedComplaintCategory", null);
  }

  async submitCategory() {
    if (this.selectedCategory.categoryID === '') {
      return this.snackBar.warning("Category field is required");
    }
    if (this.selectedCategory.categoryText === '') {
      return this.snackBar.warning("Category Text field is required");
    }
    if (this.selectedCategory.helpText === '') {
      return this.snackBar.warning("Help Text field is required");
    }
    try {
      sessionStorage.setItem("selectedCategory", null);
      this.complaintService.saveComplaintCategory(this.selectedCategory).then((response: any) => {
        this.snackBar.success('Category saved');
        this.evnt.adCategoryMessageEvent.emit('refreshCategory');
        this.close();
      });
    } catch (error) {
      this.snackBar.error("Error while saving category");
      console.log('Error:' + error);
    }


  }
}
